import React, { Component } from 'react';
import './radioButtons.scss';

/** @import { RadioButtonsProps, RadioButtonsState } from './RadioButtonsTypes' */

const getSelectedFromProps = (/** @type {RadioButtonsProps} */ props) => {
  return props.options.findIndex(x => x && x.value === props.value);
};

/** @extends {Component<RadioButtonsProps, RadioButtonsState>} */
class RadioButtons extends Component {
  constructor(/** @type {RadioButtonsProps} */ props) {
    super(props);

    this.state = {
      selected: getSelectedFromProps(props)
    };
  }

  static getDerivedStateFromProps(/** @type {RadioButtonsProps} */ props) {
    if (!props.hasOwnProperty('value')) return null;
    return {
      selected: getSelectedFromProps(props)
    };
  }


  selectOption = (/** @type {number} */ index) => (/** @type {React.MouseEvent<HTMLDivElement, MouseEvent>} */ _e) => {
    if (this.props.disabled) return;

    this.setState({ selected: index }, () => {
      // @ts-expect-error - this will be revisited with Contact Us component
      this.props.onChange && this.props.onChange(this.props.options[index] && this.props.options[index].value);
    });
  }

  isOptionSelected(/** @type {number} */ index) {
    return this.state.selected === index;
  }

  renderOptions() {
    return this.props.options.map((option, i) => option && (
      <div
        key={option.value.toString()}
        className='radio-buttons__item-wrapper'
        onClick={this.selectOption(i)}
      >
        <input
          readOnly
          className='radio-buttons__input'
          type='radio'
          name={`${this.props.name}[]`}
          value={option.value}
          checked={this.isOptionSelected(i)}
          disabled={this.props.disabled}
          ref={i === 0 ? this.props.inputRef : null}
        />
        <div className='radio-buttons__indicator' />
        <p className='radio-buttons__label'>
          {option.label}
        </p>
      </div>
    ));
  }

  getClassNames() {
    return [
      'radio-buttons',
      this.props.vertical ? 'radio-buttons--vertical' : ''
    ].join(' ').trim();
  }

  render() {
    return (
      <div className={this.getClassNames()}>
        {this.renderOptions()}
      </div>
    );
  }
}

export default RadioButtons;
